import httpClient from "../../api/httpClient";
import ContratoItem from "../classes/ContratoItem";
import ContratoItemOrigem from "../classes/ContratoItemOrigem";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Contrato/" },
  { method: "GET", rota: "Contrato/RecuperaItemContrato/Contrato/Item/{id}" },
  { method: "POST", rota: "ContratoItem/Adicionar" },
  { method: "PUT", rota: "ContratoItem/Atualizar" },
  { method: "POST", rota: "ContratoItem/Apagar" },
  { method: "GET", rota: "Contrato/All/Projetos" },
  { method: "GET", rota: "Contrato/Historico/Contrato/Item/{id}/Historico" }, // method field isnt used
];

const cacheKey: string = "ContratoItemCache";
const cacheKeySelC: string = "ContratoItemSelecionado";
const cacheKeyContractSelected = 'ContratoSelecionado';

const apiServico: String = "PLANEJAMENTO"

interface UpdateSAP {
  originalItem: ContratoItem;
  newSAPCode: string
}

class ContratoItemDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }

  async Toggle(id: number) {
    await super.put(`ItemContratoOrigem/toggle/${id}`, null);
  }

  async ListarOrigens(contratoItemId: number): Promise<ContratoItemOrigem[]> {
    return await super.Get(`ItemContratoOrigem/ItemContrato/${contratoItemId}`)
    .then((response) => {
      return response.data;
    })
    .catch((erro) => {
      console.error(erro)
    });
  }

  async ListarOrigensDoSku(sku: number, contrato: string, projeto?: string){
    let paramProjeto = projeto ? `?projeto=${projeto}` : '';
    return await super.Get(`ItemContratoOrigem/Contrato/${contrato}/Sku/${sku}${paramProjeto}`)
    .then((response) => {
      return response.data;
    })
    .catch((erro) => {
      console.error(erro)
    });
  }

  async AtualizarOrigem(item: ContratoItemOrigem){
    await super.put('ItemContratoOrigem', item);
  }

  async AdicionarOrigem(item: ContratoItemOrigem){
    await super.post('ItemContratoOrigem', item);
  }

  async ApagarOrigem(id: number){
    await super.delete(`ItemContratoOrigem/${id}`, null);
  }

  async Adicionar(value: ContratoItem) {
    return new Promise((resolve, reject) => {
      let ok: boolean = false;
      let error: any = undefined;
      super.post(calls[2].rota, value).then((result) => {
        ok = JSON.parse(result);
        resolve(ok);
      }).catch((erro) => {
        ok = false;
        error = erro;
        reject({ ok, error });
      });
    })
  }

  Atualizar(value: ContratoItem) {
    let ok: boolean = false;
    let error: any = undefined;
    super.put(calls[3].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  async Apagar(value: ContratoItem) {
    return await super.post(calls[4].rota, value).then((result) => {
      return result;
    }).catch((erro) => {
      console.log(erro);
      return false;
    });
  }

  async ListarAtivos(numeroContrato: string, codigoFornecedorSap: number): Promise<ContratoItem[]> {
    return await super.Get(calls[0].rota + numeroContrato + "/Item/All/" + codigoFornecedorSap)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): ContratoItem[] {
    let result: ContratoItem[] = JSON.parse(localStorage.getItem(cacheKey) || '[]');
    return result;
  }

  AdicionarListaAoCache(value: ContratoItem[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
    this.AtualizarListaDeItensContratoNoCache(value);
  }
  AtualizarListaDeItensContratoNoCache(value: ContratoItem[]) {
    try {
      const prev = localStorage.getItem(cacheKeyContractSelected);
      if (prev) {
        const contractSaved = JSON.parse(prev);
        const itensContract = value;
        localStorage.setItem(cacheKeyContractSelected, JSON.stringify({ ...contractSaved, itensContrato: itensContract }));
      }
    } catch (err) {
      console.log('Erro ao tentar atualizar os itens do contrato ao cache. ', err);
    }
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

  /**
   * @description Update sap contract of the current item
   * @async
   * @param {Object} data - Object to update sap
   * @param {string} data.originalItem - The original item to update
   * @param {string} data.newSAPCode - The new sap contract of the item to update
   * @returns result of update
   */
  async updateSAPOfSKU({ originalItem, newSAPCode }: UpdateSAP) {
    const response = await super.put(calls[3].rota, { ...originalItem, contratoSap: newSAPCode });
    if (!response) {
      throw new Error('Failed to update sap');
    }
    return response;
  }

  async getSAPHistoryChanges({ id }: { id: string }) {
    const response = await super.Get(`${calls[6].rota.replace('{id}', id)}`);
    if (!response || response.status !== 200) {
      throw new Error(`Failed on get sap history of id: ${id}`);
    }
    return response;
  }
}
export default ContratoItemDataset;

